import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';

import { ViajeEAD } from "./viajeead";
import { Guia } from "./guia";

const controller = rpcController("ViajeApp");

export const ViajeApp = cacheResource({
    /**Obtiene los datos offline para el inicio de un viaje de EAD en la app */
    ObtenerDatosViajeApp: async (idViajeEAD: number): Promise<models.DatosViajeEADApp> => await controller('ObtenerDatosViajeApp', { idViajeEAD }),

    /**Marca un viaje de EAD como iniciado en la app, verifica que no este iniciado ya */
    IniciarViajeApp: async (idViajeEAD: number): Promise<void> => await controller('IniciarViajeApp', { idViajeEAD }),

    /**Marca un viaje de EAD como finalizado y actualiza todos los status necesarios  */
    FinalizarViajeApp: async (idViajeEAD: number, model: models.ModeloViajeApp): Promise<void> => await controller('FinalizarViajeApp', { idViajeEAD }, model),

    /**
     * Sincroniza un modelo de viaje, aplicando los cambios a la base de datos. Se considera que las entregas realizadas y las incompletas son inmutables por lo que 
     * la sincronización solo implica agregar los registros que no existan a la base de datos
     */
    SincronizarModeloViaje: async (idViajeEAD: number, model: models.ModeloViajeApp): Promise<void> => await controller('SincronizarModeloViaje', { idViajeEAD }, model),

    /**
    * Obtiene los datos de trabajo de la app móvil, la unica razón por la cual el dispositivo quisiera obtner los datos del servidor es porque se hayan borrado
    * de forma no intencional del localStorage, por ejemplo que el navegador reclame el espacio del dispositivo.
    */
    ObtenerModeloViaje: async (): Promise<models.ModeloViajeApp> => await controller('ObtenerModeloViaje', {}),

    /**Obtiene el id del viaje del usuario en caso de que lo haya iniciado desde la app */
    ObtenerIdViajeEADUsuario: async (): Promise<number | null> => await controller('ObtenerIdViajeEADUsuario', {}),

    /**Cancela el viaje actualmente iniciado en la app  */
    CancelarViajeApp: async (idViajeEAD: number): Promise<void> => await controller('CancelarViajeApp', { idViajeEAD }),
}, {

}, {
    IniciarViajeApp: true,
    FinalizarViajeApp: true,
    SincronizarModeloViaje: true,
    CancelarViajeApp: true
});

addOnInvalidateHandler(ViajeApp, () => invalidateResource(ViajeEAD)); 
addOnInvalidateHandler(ViajeApp, () => invalidateResource(Guia));


// WEBPACK FOOTER //
// ./app/resources/items/viajeapp.tsx